var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sabc_audio_outer"},[_c('div',{staticClass:"container"},[_c('div',[(_vm.radioStation)?_c('h1',[_vm._v("Radio Station "+_vm._s(_vm.radioStation.toUpperCase()))]):_c('h1',[_vm._v("Radio No Found.")]),_vm._v(" "),_c('div',{staticClass:"player-container",domProps:{"innerHTML":_vm._s(_vm.channelHTML)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }